import "intersection-observer";
import svg4everybody from "svg4everybody";
import LazyLoad from "vanilla-lazyload";
import Autosize from "autosize";
import WidgetSlider from "Components/WidgetSlider";
import EditionSlider from "Components/EditionSlider";
import MediaBlock from "Components/MediaBlock";
import PhotoSlider from "Components/PhotoSlider";
import ArticlesPreviews from "Components/ArticlesPreviews";
import Map from "Components/Map";
import ButtonScrollTop from "Components/ButtonScrollTop";
import PartnersPreviews from "Components/PartnersPreviews";
import HeaderFixed from "Components/Header";
import MapRelocation from "Components/MapRelocation";
import TextField from "Components/TextField";
import Subscribe from "Components/Subscribe";
import ContactForm from "Components/ContactForm";
import Tabs from "Components/Tabs";
import EditionsSlider from "Components/Editions";
import JournalSlider from "Components/JournalSlider";
import Select from "Components/Select";
import ScrollLoad from "Components/MediaPreviewsList";
import Search from "Components/Search";
import ResetCheckbox from "Components/DocumentsRegion";
import Sidebar from "Components/Sidebar";
import OtherEditionsSlider from "Components/OtherEditions";
import OtherMediaSlider from "Components/OtherMedia";
import Inputmask from "inputmask";
// import $ from "jquery";

document.addEventListener("DOMContentLoaded", () => {
  svg4everybody();

  // const newsListElement = document.querySelector(".js-news-list");

  // if (newsListElement) {
  //   NewsList(newsListElement);
  // }

  initSelects();

  function initSelects() {
    const selectsElements = document.querySelectorAll(".js-select");

    for (let i = 0, len = selectsElements.length; i < len; i++) {
      Select(selectsElements[i]);
    }
  }

  const inputsData = document.querySelectorAll(".js-text-field-input-data");

  if (inputsData) {
    // console.log("time", inputsTime );
    for (let i = 0, len = inputsData.length; i < len; i++) {
      new Inputmask({ mask: "99.99.9999" }).mask(inputsData[i]);
    }
  }

  const documentsCheckbox = document.querySelectorAll(
    ".js-documents-region-checkbox"
  );

  if (documentsCheckbox.length > 0) {
    ResetCheckbox(documentsCheckbox);
  }

  const subscribeBlockElement = document.querySelector(".js-subscribe");

  if (subscribeBlockElement) {
    Subscribe(subscribeBlockElement);
  }

  const searchBlockElement = document.querySelector(".js-search");

  if (searchBlockElement) {
    Search(searchBlockElement);
  }

  const contactBlockElement = document.querySelector(
    ".js-contact-form-wrapper"
  );

  if (contactBlockElement) {
    ContactForm(contactBlockElement);
  }

  const textareaElements = document.getElementsByClassName(
    "js-textarea-autosize"
  );

  if (textareaElements.length) {
    new Autosize(textareaElements);
  }

  const textFieldElements = document.querySelectorAll(".js-text-field-input");

  for (let i = 0, len = textFieldElements.length; i < len; i++) {
    TextField(textFieldElements[i]);
  }

  const mapRelocationElement = document.querySelector(".js-map-relocation");

  if (mapRelocationElement) {
    MapRelocation(mapRelocationElement);
  }

  const headerElement = document.querySelector(".header");

  if (headerElement) {
    HeaderFixed(headerElement);
  }

  const partnersPreviewsElement = document.querySelector(".partners-previews");

  if (partnersPreviewsElement) {
    PartnersPreviews(partnersPreviewsElement);
  }

  const widgetSliderElements = document.querySelectorAll(".js-widget-slider");

  for (let i = 0, len = widgetSliderElements.length; i < len; i++) {
    WidgetSlider(widgetSliderElements[i]);
  }

  const editionSliderElements = document.querySelectorAll(".js-edition-slider");

  for (let i = 0, len = editionSliderElements.length; i < len; i++) {
    EditionSlider(editionSliderElements[i]);
  }

  const mediaSliderElements = document.querySelectorAll(".js-media-slider");

  for (let i = 0, len = mediaSliderElements.length; i < len; i++) {
    MediaBlock(mediaSliderElements[i]);
  }

  const scrollLoadElements = document.querySelectorAll(
    ".js-scroll-load-container"
  );

  if (scrollLoadElements) {
    for (let i = 0, len = scrollLoadElements.length; i < len; i++) {
      ScrollLoad(scrollLoadElements[i]);
    }
  }

  const photoSliderElements = document.querySelectorAll(".js-photo-slider");

  if (photoSliderElements) {
    for (let i = 0, len = photoSliderElements.length; i < len; i++) {
      PhotoSlider(photoSliderElements[i]);
    }
  }

  const editionsSliderElement = document.querySelector(
    ".js-editions-slider-container"
  );

  if (editionsSliderElement) {
    EditionsSlider(editionsSliderElement);
  }

  const journalSliderElement = document.querySelectorAll(".js-journal-slider");

  if (journalSliderElement.length !== 0) {
    journalSliderElement.forEach(e => {
      JournalSlider(e);
    });
  }

  const articlesPreviewsElements = document.querySelectorAll(
    ".js-articles-previews"
  );

  for (let i = 0, len = articlesPreviewsElements.length; i < len; i++) {
    ArticlesPreviews(articlesPreviewsElements[i]);
  }

  const mapElement = document.querySelector(".js-map");

  if (mapElement) {
    Map(mapElement);
  }

  const buttonScrollTopElement = document.querySelector(
    ".js-button-scroll-top"
  );

  if (buttonScrollTopElement) {
    ButtonScrollTop(buttonScrollTopElement);
  }

  const tabsElement = document.querySelector(".js-tabs");

  if (tabsElement) {
    Tabs(tabsElement);
  }

  const closeElement = document.querySelector(".js-cookie-close");
  const cookieBlockElement = document.querySelector(".js-cookie");

  if (closeElement && localStorage) {
    if (!localStorage.getItem("fcookie")) {
      cookieBlockElement.classList.remove("is-hidden");
    }

    closeElement.addEventListener("click", function closeCookie() {
      localStorage.setItem("fcookie", 1);
      cookieBlockElement.classList.add("is-hidden");
    });
  }

  const sidebarElements = document.querySelectorAll(".js-sidebar");

  if (sidebarElements) {
    Sidebar(sidebarElements);
  }

  const otherEditionsElement = document.querySelector(
    ".js-other-editions-slider-container"
  );

  if (otherEditionsElement) {
    OtherEditionsSlider(otherEditionsElement);
  }

  const otherMediaElement = document.querySelector(".js-other-media-container");

  if (otherMediaElement) {
    OtherMediaSlider(otherMediaElement);
  }
});

window.addEventListener("load", () => {
  /* if (
    document.documentElement.clientWidth > 600 &&
    document.documentElement.clientWidth < 1201
  ) {
    document
      .querySelector("meta[name=viewport]")
      .setAttribute("content", "width=1201");
  } */

  setTimeout(function scrollPage() {
    window.scrollTo(0, 0);
  }, 0);

  const relocationImg = document.querySelector(".js-region-detailed-info-img");

  new LazyLoad({
    elements_selector: ".js-lazy-img"
  });

  new LazyLoad({
    elements_selector: ".js-lazy-img-webp",
    to_webp: true
  });

  if (relocationImg) {
    loadImg();
  }

  function loadImg() {
    const marginTopImg = relocationImg.clientHeight / 2;
    relocationImg.style.marginTop = `${-1 * marginTopImg}px`;
  }

  if (document.querySelector(".experience-preview")) {
    const wrapperSlider = document
      .querySelector(".experience-preview")
      .closest(".js-widget-slider-wrapper");

    if (wrapperSlider.querySelector(".swiper-slide-active")) {
      wrapperSlider.style.height = `${
        wrapperSlider.querySelector(".swiper-slide-active").clientHeight
      }px`;
    }
  }
});
